import { Box, Button, keyframes, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'

function PageNotFound() {
    const [animation, setanimation] = useState("")


    let animate=keyframes`
    0%{
        transform:translate(-50px,400px);
    }
    50%{
        transform:translate(-70px,50px);
    }
    100%{
        transform:translate(-70px,70px);
    }
    `
    let animate2 = keyframes`
    // 0%{
    //     transform:translate(0px,0px);
    // }
    50%{
    transform:translate(-30px,30px);
    }
    75% {
        transform:translate(-30px,40px);
    }
    100%{
        transform:translate(-40px,45px);
    }
    `
    let rotate = keyframes`
    0%{
        transform:rotate(0deg);
    }
    50%{
        transform:rotate(5deg);
    }
    75%{
        transform:rotate(3deg);
    }
    100%{
        transform:rotate(5deg);
    }
    `
  return (
    <Box
        sx={{
            display:"flex",
            flexDirection:"column",
            height:"100vh",
            justifyContent:"center",
            alignItems:"center",


        }}
    >
        <Box
            sx={{
                position:"relative",
                //   backgroundColor: 'red'
                  marginTop: "400px"


            }}
        >
              <Box
                  sx={{
                      backgroundColor: "rgb(192, 192, 192)",
                      width: "300px",
                      height: "300px",
                      borderRadius: "100%",
                      transform: "scaleY(0.35)",
                    //   zIndex: "301"

                    }}
              />
              <Box
                  sx={{
                      backgroundImage: "radial-gradient( rgb(158, 156, 156), rgb(48, 48, 48))",
                      width: "300px",
                      height: "300px",
                      borderRadius: "100%",
                      transform: "scaleY(0.3)",
                      position:"absolute",
                      bottom:'-5px',
                      left:"0px",
                    //   zIndex: "550"

                  }}
              />
              
              <Box
                  sx={{
                    width: "300px",
                    height: '400px',
                    position: "absolute",
                    top: "-250px",
                    left: "0px",
                    overflow:"hidden",
                    animation: `${animate2} 1s linear forwards`,

                    //   zIndex: "503"


                  }}
              >
                  <Box
                    sx={{
                        position:"relative",
                        transform: "translate(-50px,400px)",
                        animation: `${animate} 1s linear forwards`,
                        // backgroundColor:"red",
                    }}
                  >
                      <Box
                          component="img"
                          src='./images/pageNotFoundImg.png'
                          sx={{
                              width: "400px",
                              //   border: "1px solid black",
                              //   zIndex: 10
                          }}
                      />
                      <Box
                        p={2}
                        sx={{
                            position:"absolute",
                            top:"-50px",
                            left:"100px",
                            backgroundColor:'white',
                            border:"2px solid black",
                            animation: `${rotate} 0.5s linear 2s forwards `,

                        }}
                      >
                        <Typography variant="h3" color="initial">
                            404
                        </Typography>
                        <Typography variant="h6" color="initial">
                            Page Not Found!!
                        </Typography>
                        <Button 
                            component="a"
                            href='../'  
                            variant='contained' 
                            sx={{
                                color:"white",
                                backgroundColor:"black",
                                border:"1px solid black",
                                '&:hover':{
                                    backgroundColor:"white",
                                    color:"black",
                                }
                            }}>
                            Go Home
                        </Button>
                      </Box>
                  </Box>

              </Box> 
             
        </Box>
       
    </Box>
  )
}

export default PageNotFound